/* tslint:disable */
/* eslint-disable */
/**
 * Opus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OK,
} from '../models/index';
import {
    OKFromJSON,
    OKToJSON,
} from '../models/index';

/**
 * 
 */
export class DebugApi extends runtime.BaseAPI {

    /**
     * Used as a target for monday.com custom application actions, will produce info level logs containing full payload.
     * Monday.com debug action
     */
    async webhookMondayDebugActionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OK>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/webhook/monday/debug/action`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OKFromJSON(jsonValue));
    }

    /**
     * Used as a target for monday.com custom application actions, will produce info level logs containing full payload.
     * Monday.com debug action
     */
    async webhookMondayDebugAction(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OK> {
        const response = await this.webhookMondayDebugActionRaw(initOverrides);
        return await response.value();
    }

}
